import { isNativeApp, openExternalUrl } from './platform';
import { buildAndroidPlayStorePromotionUrl } from './storeUpdates';

export const ANDROID_APP_PROMOTION_VERSION = 1;

type NavigatorWithUserAgentData = Navigator & {
  userAgentData?: {
    platform?: string;
    mobile?: boolean;
  };
};

const normalizeEmailForStorage = (email?: string | null): string => (email || 'anonymous').trim().toLowerCase();

export const isAndroidDevice = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const userAgentData = (navigator as NavigatorWithUserAgentData).userAgentData;
  if (userAgentData?.platform && /android/i.test(userAgentData.platform)) {
    return true;
  }

  return /android/i.test(navigator.userAgent || '');
};

export const isAndroidWebRuntime = (): boolean => isAndroidDevice() && !isNativeApp();

export const getAndroidPromotionDismissalKey = (userEmail?: string | null): string =>
  `wereader.androidAppPromotion.v${ANDROID_APP_PROMOTION_VERSION}.${normalizeEmailForStorage(userEmail)}`;

export const isAndroidPromotionDismissed = (userEmail?: string | null): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.localStorage.getItem(getAndroidPromotionDismissalKey(userEmail)) === 'dismissed';
};

export const dismissAndroidPromotion = (userEmail?: string | null): void => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(getAndroidPromotionDismissalKey(userEmail), 'dismissed');
};

export const getAndroidAppPromotionUrl = (placement: string): string =>
  buildAndroidPlayStorePromotionUrl(placement);

export const openAndroidAppPromotion = async (placement: string, options?: { replace?: boolean }): Promise<void> => {
  await openExternalUrl(getAndroidAppPromotionUrl(placement), options);
};
